import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE; // Ensure this env variable is set

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

// --- Fetch all Jenis Soal with pagination and filters ---
// export const fetchJenisSoal = async ({
//   page = 1,
//   per_page = 10,
//   filters = {},
//   disable_pagination = false,
// }) => {
//   try {
//     const params = new URLSearchParams();

//     // 1. Tentukan parameter paginasi atau non-paginasi
//     if (disable_pagination) {
//       params.append('disable_pagination', 'true');
//     } else {
//       params.append('page', page);
//       params.append('per_page', per_page);
//     }


//     // 2. Tambahkan semua filter yang ada di objek 'filters'
//     // Memastikan filters adalah objek sebelum diiterasi
//     if (filters && typeof filters === 'object') {
//       Object.keys(filters).forEach(key => {
//         // Hanya tambahkan filter yang memiliki nilai dan bukan string kosong
//         if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
//           // Asumsikan nama filter di API sama dengan kunci objek filters
//           params.append(key, filters[key]);
//         }
//       });
//     }

//     // 3. Panggil API dengan parameter yang sudah disiapkan
//     const response = await axios.get(`${BASE_URL_BE}/jenis_soal?${params.toString()}`, {
//       headers: getAuthHeaders() // Pastikan header otorisasi disertakan
//     });

//     // 4. Validasi respons dari API
//     if (!response.data || !response.data.data) {
//         // Jika respons tidak sesuai format yang diharapkan, lemparkan error
//         throw new Error("Invalid API response format: 'data' property is missing.");
//     }

//     // 5. Hitung metadata berdasarkan respons
//     const meta = response.data.meta || {};
//     let calculated_last_page = 1;
//     let currentPage = 1;
//     let currentPerPage = response.data.data.length;
//     let totalItems = response.data.data.length;

//     if (!disable_pagination) {
//       // Jika paginasi aktif, gunakan metadata dari respons
//       totalItems = meta.total || 0;
//       currentPage = meta.page || page;
//       currentPerPage = meta.per_page || per_page;
//       calculated_last_page = Math.ceil(totalItems / currentPerPage) || 1;
//     }

//     // 6. Kembalikan data dan metadata dalam format yang konsisten
//     return {
//       data: response.data.data,
//       meta: {
//         page: currentPage,
//         per_page: currentPerPage,
//         total: totalItems,
//         last_page: calculated_last_page,
//       },
//     };
//   } catch (error) {
//     // 7. Penanganan error yang lebih informatif
//     console.error("Error fetching Jenis Soal:", error.response?.data?.message || error.message);
//     // Lemparkan error agar bisa ditangkap oleh komponen yang memanggil
//     throw error;
//   }
// };


export const fetchJenisSoal = async (options = {}) => {
  try {
    const params = new URLSearchParams();

    console.log(options.id_tipe_konten, "ini tipe konten service")

    // Add filter for tipe konten if provided
    if (options.id_tipe_konten) {
      params.append('id_tipe_konten', options.id_tipe_konten);
    }

    if (options.id_jenis_seleksi) {
      params.append('id_jenis_seleksi', options.id_jenis_seleksi);
    }

    // Pagination logic
    if (options.disable_pagination) {
      params.append('disable_pagination', 'true');
    } else {
      params.append('page', options.page || 1);
      params.append('per_page', options.per_page || 10);
    }

    // Add search filter if provided
    if (options.search) {
      params.append('search', options.search);
    }

    const response = await axios.get(`${BASE_URL_BE}/jenis_soal?${params.toString()}`, {
      headers: getAuthHeaders()
    });

    const meta = response.data.meta || {};
    const calculated_last_page = options.disable_pagination ? 1 : (Math.ceil(meta.total / meta.per_page) || 1);
    const currentPage = options.disable_pagination ? 1 : (meta.page || (options.page || 1));
    const currentPerPage = options.disable_pagination ? (meta.total || response.data.data.length || (options.per_page || 10)) : (meta.per_page || (options.per_page || 10));

    return {
      success: response.data.success,
      data: response.data.data || [],
      message: response.data.message || "",
      code: response.data.code || 200,
      meta: {
        page: currentPage,
        per_page: currentPerPage,
        total: meta.total || (options.disable_pagination ? response.data.data.length : 0),
        last_page: calculated_last_page
      }
    };
  } catch (error) {
    console.error("Error fetching Jenis Seleksi:", error);
    throw {
      success: false, 
      message: error.response?.data?.message || "Failed to fetch jenis seleksi",
      errors: error.response?.data?.errors,
      code: error.response?.status
    };
  }
};

// --- Create a new Jenis Soal ---
export const createJenisSoal = async (formData) => {
  try {
    // ############ UPDATED API ENDPOINT ############
    const response = await axios.post(`${BASE_URL_BE}/jenis_soal`, formData, {
      headers: {
        ...getAuthHeaders(),
        // Assuming your backend expects multipart/form-data for this endpoint
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating Jenis Soal:", error); // ############ UPDATED CONSOLE LOG ############
    throw error;
  }
};

// --- Update an existing Jenis Soal ---
export const updateJenisSoal = async (id_jenis_soal, formData) => { // ############ RENAMED ID PARAMETER ############
  try {
    // ############ UPDATED API ENDPOINT AND ID ############
    const response = await axios.put(`${BASE_URL_BE}/jenis_soal/${id_jenis_soal}`, formData, {
      headers: {
        ...getAuthHeaders(),
        // Assuming your backend expects multipart/form-data for this endpoint
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating Jenis Soal:", error); // ############ UPDATED CONSOLE LOG ############
    throw error;
  }
};

// --- Delete a Jenis Soal ---
export const deleteJenisSoal = async (id) => {
  try {
    // ############ UPDATED API ENDPOINT ############
    const response = await axios.delete(`${BASE_URL_BE}/jenis_soal/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting Jenis Soal:", error); // ############ UPDATED CONSOLE LOG ############
    throw error;
  }
};

